import { createContext, useContext } from 'react'

export interface ChatFilesValue {
  files: Array<File>
  setFiles: (files: Array<File>) => void
}

export const ChatFilesContext = createContext<ChatFilesValue | null>(null)

export function useChatFiles(): ChatFilesValue {
  const ctx = useContext(ChatFilesContext)
  if (!ctx) throw new Error('useChatFiles must be used within TripPlannerChatProvider')
  return ctx
}
